import React, { Component } from 'react';
import { FaApple, FaAndroid} from 'react-icons/fa';
import ReactGA from "react-ga";


export class PlayStoreButton extends Component {
	constructor(props) {
		super(props);
		this.state = {};

		this.goStore = this.goStore.bind(this);
	}

	goStore(e, platform) {

		ReactGA.event({
			category: 'STORE',
			action: platform
		});

		let storeURL = platform == 'android' ? 'https://halasz.page.link/amTC' : 'https://halasz.page.link/29hQ';
		window.open(storeURL);
	}

	render() {
		return (
			<div className="playstore-btns">
				<a onClick={(e) => this.goStore(e, 'ios')} target="_blank" className="primary-btn mr-10">
					<span className="mr-10 d-inline-block ml-0">
						<FaApple/>
					</span>
					<h4>Available</h4>
					<p>on App Store</p>
				</a>
				<a onClick={(e) => this.goStore(e, 'android')} target="_blank" className="primary-btn">
					<span  className="mr-10 d-inline-block ml-0">
						<FaAndroid />
					</span>
					<h4>Download</h4>
					<p>from Play Store</p>
				</a>
			</div>
		);
	}
}
